import React from 'react';
import styled from 'styled-components';

import {CalendarView} from '@ibibo/dcalendar';
import addDays from '@ibibo/date-utils/src/addDays';

// import {addDays} from '../../../../../shared/utils/date-utils';
// import {maxAllowedRoomNights, defaultLengthOfStay} from '../../../../../shared/config/app-config';

const CalendarBlock = React.forwardRef(
  (
    props: {
      isStartMode;
      isEndMode;
      onSelection;
      updateQueryCaller;
      startDate;
      endDate;
      showMaxEndDate;
      isSingleDateMode;
      allowPastDate;
    },
    ref,
  ) => {
    const {
      isStartMode,
      isEndMode,
      onSelection,
      updateQueryCaller,
      startDate,
      endDate,
      showMaxEndDate,
      isSingleDateMode,
      allowPastDate = true
    } = props;
    const MAX_TIMESTAMP = 8640000000000000;

    const getClassName = (dateObj: Date, startDateObj?: Date, endDateObj?: Date) => {
      if (
        startDateObj &&
        dateObj.getMonth() === startDateObj.getMonth() &&
        dateObj.getDate() === startDateObj.getDate() &&
        dateObj.getFullYear() === startDateObj.getFullYear()
      ) {
        return 'leftactive';
      }
      if (
        endDateObj &&
        dateObj.getMonth() === endDateObj.getMonth() &&
        dateObj.getDate() === endDateObj.getDate() &&
        dateObj.getFullYear() === endDateObj.getFullYear()
      )
        return 'rightactive';
      if (
        startDateObj &&
        endDateObj &&
        dateObj.getTime() > startDateObj.getTime() &&
        dateObj.getTime() < endDateObj.getTime()
      )
        return 'partial';
      return '';
    };

    const dateOnClickHandler = dateObj => {
      if (isStartMode) {
        updateQueryCaller({
          startDate: dateObj,
          endDate,
        });
        onSelection();
      } else if (isSingleDateMode) {
        updateQueryCaller({
          startDate: dateObj,
        });
        onSelection();
      } else {
        updateQueryCaller({
          startDate,
          endDate: dateObj,
        });
        onSelection();
      }
    };

    const todaysDate = new Date();

    const maxDateInfnity = new Date(MAX_TIMESTAMP);

    // 1st May is the start date for wallet transaction calendar.
    // Reason: we went live in July and started out testing from may and hence we have data from may 2020 onwards
    const minDateAllowed = allowPastDate ?  new Date(2020, 4, 1) : new  Date();
    if (isEndMode) {
      minDateAllowed.setDate(startDate.getDate());
    }
    let monthToBeDisplayed = todaysDate.getMonth();
    let yearToBeDisplayed = todaysDate.getFullYear();

   if(!allowPastDate && startDate >= todaysDate){
         monthToBeDisplayed = startDate.getMonth();
         yearToBeDisplayed = startDate.getFullYear();
   }
    return (
      <CalendarBlockOuterWrapper ref={ref}>
        <CalendarView
          monthToBeDisplayed={monthToBeDisplayed}
          yearToBeDisplayed={yearToBeDisplayed}
          minDateAllowed={minDateAllowed}
          maxDateAllowed={showMaxEndDate ? maxDateInfnity : todaysDate}
          renderDateItem={({keyVal, value, dateObj}) => {
            if (!value) {
              return (
                <li key={keyVal}>
                  <span></span>
                </li>
              );
            }

            let isValid = true;

            dateObj.setHours(0, 0, 0, 0);

            todaysDate.setHours(0, 0, 0, 0);
            if (isStartMode) {
              if (!showMaxEndDate) isValid = dateObj <= todaysDate;
            }

            if (isEndMode) {
              startDate.setHours(0, 0, 0, 0);
              isValid = dateObj <= todaysDate && dateObj >= startDate;
            }
            if(!allowPastDate){
              isValid = dateObj >= todaysDate;
            }

            return (
              <li
                key={keyVal}
                style={
                  isValid
                    ? {color: 'black', cursor: 'pointer'}
                    : {opacity: '0.4', color: 'grey', cursor: 'default'}
                }
                onClick={e => {
                  isValid ? (dateOnClickHandler(dateObj), e.stopPropagation()) : () => {};
                }}
              >
                <span className={getClassName(dateObj, startDate, endDate)}>{value}</span>
              </li>
            );
          }}
        />
      </CalendarBlockOuterWrapper>
    );
  },
);

export default CalendarBlock;

const CalendarBlockOuterWrapper = styled.div(
  props => `
    width: 33.5rem;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: 3.3rem;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: ${props.theme.misc.borderRadius.base};
  `,
);
